import React, { Component } from 'react';
import * as qs from 'query-string';
import { connect } from 'shalala';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col, Form } from 'react-bootstrap';

import Uuid from '../../../support/Uuid';
import { useStore } from '../../../store';
import UuidForm from './components/UuidForm';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import EmisorSeriesManager from './components/EmisorSeriesManager';
import ResponseError from '../../../shared/responses/ResponseError';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../../shared/responses/ResponseResult';
import EmisorSectorPrimarioFiscalInfoForm from './components/EmisorSectorPrimarioFiscalInfoForm';
import EmisorSectorPrimarioFiscalAddressForm from './components/EmisorSectorPrimarioFiscalAddressForm';

class EmisorSectorPrimarioProductorRegistration extends Component {
  steps = {
    fiscal_info: false,
    fiscal_address: false,
  };

  state = {};

  constructor(props) {
    super(props);

    const { id } = props.match.params;
    const { data = {}, tenancy } = props;

    this.state = {
      id,
      data: data,
      steps: this.steps,
    };

    if (tenancy) {
      props.upsertActions.setPartialState({ tenancy });
    }

    const query = qs.parse(this.props.location.search);

    if (query.t === 'l') {
      props.upsertActions.setPartialState({ tenancy: 'fa/live' });
    }

    props.upsertActions.setPartialState(this.state);
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.upsertActions.setPartialState({
        error: undefined,
        __action: action,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    if (!!this.props.onComplete) {
      this.props.onComplete();
    }
  };

  handleOnSubmit = async () => {
    const {
      data,
      data: { direccion = {} },
    } = this.props.upsert;

    const keys = Object.keys(data);

    let info = {};

    for (const key of keys) {
      if (data[key] !== null) {
        info[key] = data[key];
      }
    }

    const body = {
      ...info,
      id: !!info.id ? info.id : Uuid.v4(),
      cp: direccion.cp,
      config: {
        mostrar_direccion_en_pdf: !!data.direccion.direccion,
      },
      productor: true,
      direccion: {
        ...direccion,
        pais: 'México',
      },
    };

    await this.props.upsertActions.upsert(body);

    const { result } = this.props.upsert;

    if (!!result && this.props.onComplete) {
      this.props.onComplete(result);
    }
  };

  handleOnDataChange = (event) => {
    this.props.upsertActions.setPartialState({
      ...event,
    });
  };

  handleOnSeriesChange = (event) => {
    const { data, ...rest } = event;

    this.props.upsertActions.setStepDataChange({
      ...this.props.upsert,
      ...rest,
      data: {
        ...this.props.upsert.data,
        ...data,
      },
    });
  };

  handleOnDataWithStepsChange = (event) => {
    let newEvent = {
      ...event,
      steps: {
        ...this.props.upsert.steps,
        [event.step]: event.isValid,
      },
    };

    this.props.upsertActions.setStepDataChange(newEvent);
  };

  handleOnFiscalAddressDataChange = (event) => {
    const { data, ...rest } = event;

    this.handleOnDataWithStepsChange({
      ...rest,
      data: {
        ...this.props.upsert.data,
        direccion: data,
      },
    });
  };

  handleCustomSeriesCheckboxOnChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked,
    });

    this.props.upsertActions.setStepDataChange({
      ...this.props.upsert,
      data: {
        ...this.props.upsert.data,
        series: checked ? [] : undefined,
      },
    });
  };

  renderError = () => {
    const { error } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseResult
          title="Registro completado"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { id, series_management } = this.state;
    const {
      steps,
      data = {},
      data: { series = [] },
      error,
      result,
      busy,
      fetching,
    } = this.props.upsert;
    const isValid = steps.fiscal_info && steps.fiscal_address;

    const { onComplete } = this.props;

    if (fetching) {
      return <Loading />;
    }

    return (
      <>
        {!!error && this.renderError()}

        {!!result && !onComplete && this.renderResult()}

        <Row>
          <Col md={10}>
            <div className="py-3">
              <strong className="text-info">PERSONALIZAR EMISOR</strong>
            </div>
            <UuidForm
              data={data}
              onFormDataChange={this.handleOnDataChange}
            ></UuidForm>
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={10}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">INFORMACIÓN FISCAL</strong>
            </div>

            <EmisorSectorPrimarioFiscalInfoForm
              data={data}
              readOnly={false}
              confirm={false}
              autoFocus={true}
              onFormDataChange={this.handleOnDataWithStepsChange}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={10}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">DOMICILIO FISCAL</strong>
            </div>

            <EmisorSectorPrimarioFiscalAddressForm
              step={'fiscal_address'}
              data={data.direccion ?? {}}
              onFormDataChange={this.handleOnFiscalAddressDataChange}
            />
          </Col>
        </Row>

        <div className="py-3">
          <strong className="text-info">SERIES</strong>
        </div>
        <Row>
          <Col
            xs={12}
            sm={12}
            md={10}
            lg={10}
          >
            <Form.Group controlId="series_management">
              <Form.Check
                type="checkbox"
                name="series_management"
                label="Quiero personalizar las series de este emisor."
                checked={series_management || false}
                onChange={this.handleCustomSeriesCheckboxOnChange}
              />
            </Form.Group>

            {series_management && (
              <EmisorSeriesManager
                data={series || []}
                step={'series'}
                onFormDataChange={this.handleOnSeriesChange}
              />
            )}
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
            className="py-3"
          >
            <PopConfirm
              text="Realmente deseas cancelar?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
                className="mr-2"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnSubmit}
            >
              {busy === true ? (!id ? 'Registrando...' : 'Actualizando...') : !id ? 'Registrar' : 'Actualizar'}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return { upsert: store.app.emisores.upsert };
};

const mapActions = (actions) => {
  return { upsertActions: actions.app.emisores.upsert };
};

export default withRouter(connect(useStore, mapState, mapActions)(EmisorSectorPrimarioProductorRegistration));
